import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AlarmClock, Loader2, Play } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { fmtDate, fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";

export const DelayPanel = ({ onRun }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/delay-check").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const run = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/admin/delay-check/run");
      toast.success(`Controllo completato: ${r.delayed_total} in ritardo, ${r.customers_notified} clienti avvisati`);
      load();
      onRun?.();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  const last = data?.last_run;
  return (
    <div className="mt-6 bg-white border border-slate-200 p-5 sm:p-6" data-testid="delay-panel">
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
        <div>
          <h2 className="font-display text-lg font-bold uppercase tracking-tight flex items-center gap-2"><AlarmClock className="h-5 w-5 text-red-600" /> Controllo ritardi giornaliero</h2>
          <p className="text-sm text-slate-500 mt-1">Ogni mattina alle {String(data?.config?.hour ?? 8).padStart(2, "0")}:00 il sistema cerca le spedizioni oltre la data prevista, ti invia un riepilogo via email e avvisa i clienti che hanno dato il consenso (una sola volta per ogni data prevista). Orario modificabile in Impostazioni.</p>
          <p className="text-xs text-slate-500 mt-2" data-testid="delay-last-run">
            {last ? <>Ultimo controllo: {fmtDateTime(last.finished_at || last.started_at)} ({last.source}) · {last.delayed_total ?? 0} in ritardo · {last.customers_notified ?? 0} clienti avvisati · riepilogo email: {last.owner_email || last.status}</> : "Nessun controllo ancora eseguito."}
          </p>
        </div>
        <Button onClick={run} disabled={busy} variant="outline" className="rounded-none shrink-0" data-testid="delay-run-btn">
          {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Play className="h-4 w-4 mr-1" />} Esegui ora
        </Button>
      </div>
      {data?.delayed?.length > 0 && (
        <ul className="mt-4 divide-y divide-slate-100 text-sm" data-testid="delay-list">
          {data.delayed.map((s) => (
            <li key={s.code} className="py-2 flex flex-wrap items-center gap-x-4 gap-y-1">
              <Link to={`/admin/spedizioni/${s.code}`} className="font-mono font-bold hover:text-[#E50914]" data-testid={`delay-item-${s.code}`}>{s.code}</Link>
              <span className="text-slate-600">{s.destination_city}</span>
              <span className="text-red-600 font-semibold">prevista {fmtDate(s.expected_delivery)}</span>
              <span className="text-xs text-slate-400">{s.delay_notified_at ? `segnalata il ${fmtDateTime(s.delay_notified_at)}` : "non ancora segnalata"}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
